export default __webpack_public_path__ + "static/media/lake.36245338.jpg";